import { apis } from "./base";

const sendEmailServices = apis.injectEndpoints({
  endpoints: (builder) => ({
    getAllEmailHistory: builder.query({
      query: () => `/admin/email/get-email-history`,
      transformResponse: (response) => response.response,
      providesTags: ["Emails"],
    }),
    sendEmail: builder.mutation({
      query: (body) => ({
        url: `/admin/email/send-email`,
        method: "POST",
        body: body,
      }),
    }),
  }),
});

export const { useGetAllEmailHistoryQuery, useSendEmailMutation } = sendEmailServices;
